import React from 'react'
import PropTypes from 'prop-types'
import posed from 'react-pose'

const PosedInfo = posed.div({
  start: {
    opacity: 0,
  },
  end: {
    opacity: 1,
    transition: {
      delay: 200,
      duration: 300,
    },
  },
})

const propTypes = {
  onConfirmation: PropTypes.func.isRequired,
}

const ConfirmBox = ({ onConfirmation }) => {
  return (
    <div className="p-4 bg-secondary rounded-lg">
      <PosedInfo key="info" initialPose="start" pose="end">
        <span className="block text-white text-lg font-semibold mb-4">
          Would you like to open
          <br />
          Google Maps?
        </span>
        <div className="flex justify-between">
          <button
            className={`items-center rounded-lg font-semibold select-none outline-none 
            px-5 py-3 text-sm bg-white text-secondary border border-white leading-none mr-2`}
            onClick={() => onConfirmation('yes')}
          >
            Yes, please!
          </button>
          <button
            className={`items-center rounded-lg font-semibold select-none outline-none 
             px-5 py-3 text-sm bg-secondary text-white border  leading-none`}
            onClick={() => onConfirmation('no')}
          >
            No, thanks
          </button>
        </div>
      </PosedInfo>
    </div>
  )
}

ConfirmBox.propTypes = propTypes

export default ConfirmBox
